import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import addYears from 'date-fns/addYears';
import get from 'lodash/get';

import Experiment, { Conversion, Variant } from './Experiment';
import { querystringify, analytics } from '../../utils/index';

const serverUrl = process.env.RAZZLE_SIXPACK_URL;
const cookiePrefix = 'abtest';
const userCookieName = `${cookiePrefix}`;

const getCookie = (key, req = null) => {
  if (req) {
    return req.cookies[key];
  }
  return Cookies.get(key);
};

/*
  If cookie contains value that is not in list of alternatives, 
  remove alternative
  */
const removeInvalidAlternative = (alternative, alternatives = []) => {
  if (!alternatives.includes(alternative)) {
    return;
  }
  return alternative;
};

const setCookie = (key, value, res = null) => {
  const expires = addYears(new Date(), 1);
  if (res) {
    res.cookie(key, value, { expires });
  } else {
    Cookies.set(key, value, { expires });
  }
};

const createClientId = (res = null) => {
  const id = uuidv4();
  setCookie(userCookieName, id, res);
  return id;
};

const participate = async (name, alternatives = [], req = null, res = null) => {
  const cookieName = `${cookiePrefix}_${name}`;
  let alternative = getCookie(cookieName, req);
  alternative = removeInvalidAlternative(alternative, alternatives);
  const clientId = getCookie(userCookieName, req) || createClientId(res);

  const track = alternative => {
    analytics.track('Experiment Participated', {
      name,
      clientId,
      alternative
    });
  };

  if (alternative) {
    track(alternative);
    return alternative;
  }

  const userAgent =
    typeof window !== 'undefined'
      ? window.navigator.userAgent
      : get(req, 'headers["user-agent"]', '');

  const params = {
    experiment: name,
    alternatives,
    client_id: clientId,
    user_agent: userAgent
  };

  // TODO add error handling
  const response = await fetch(
    `${serverUrl}/participate?${querystringify(params)}`
  );
  const json = await response.json();

  alternative = get(json, 'alternative.name', null);
  if (alternative) {
    setCookie(cookieName, alternative, res);
  }

  track(alternative);

  return alternative;
};

const convert = async (name, kpi = null) => {
  const cookieName = `${cookiePrefix}_${name}`;
  const clientId = getCookie(userCookieName);
  const alternative = getCookie(cookieName);

  if (!clientId) {
    console.error(
      `Convert without client_id. Cookie ${userCookieName} not set.`,
      { name, kpi }
    );
    return null;
  }

  const params = {
    experiment: name,
    client_id: clientId
  };

  if (kpi) {
    params.kpi = kpi;
  }

  const response = await fetch(
    `${serverUrl}/convert?${querystringify(params)}`
  );
  const json = await response.json();

  analytics.track('Experiment Converted', {
    name,
    alternative,
    clientId,
    kpi
  });

  return json;
};

export { Experiment, Conversion, Variant, participate, convert };
